// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Omccy","bigColWidth":"Table_bigColWidth__169oD","biggerColWidth":"Table_biggerColWidth__1VClM","row":"Table_row__1Xty2","col":"Table_col__3734R"};